module.exports = "/images/ico-bank-przelew.svg?fe48a0453aa049df18c110d42527ff0b";